import React from "react";
import clsx from "clsx";
import styles from "./styles.module.scss";
import Skeleton from "../skeleton";

export default function MessageLoading({
  className,
  ...props
}: Omit<React.ComponentPropsWithoutRef<"div">, "children"> & {}) {
  return (
    <div className={clsx(styles.messageAi, className)} {...props}>
      <header className={styles.header}>
        <img
          className={styles.avatar}
          src="https://resol.dev.onetouchai.net/static/images.jpg"
          alt=""
          width="42"
          height="42"
        />
        <div className={styles.tools}>
          <div className={styles.toolButton}  style={{ visibility: "hidden" }} >
            <Skeleton className={styles.icon} />
          </div>
          <div className={styles.toolButton}  style={{ visibility: "hidden" }} >
            <Skeleton className={styles.icon} />
          </div>
          <div className={styles.toolButton}>
            <Skeleton className={styles.icon} />
          </div>
        </div>
      </header>
      <div className={styles.body}>
        <Skeleton className={styles.skeleton1} />
        <Skeleton className={styles.skeleton1} />
        <Skeleton className={styles.skeleton2} />
      </div>
    </div>
  );
}
